import * as React from 'react'
import './full-page-content.css'


export default class extends React.Component{

    render(){
        return (
            <div className="full-page-content">
                { this.props.children }
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/full-page-content.tsx